import React from "react";

import "./PopoverMenu.css";
import { Popover } from "antd";

const getVisibleMenuItems = (menuItems = []) => menuItems.filter((item) => {
  const isVisible = typeof item.isVisible === "function" ? item.isVisible() : item.isVisible;
  return isVisible !== false;
});

export default function PopoverMenu({
  children, menuItems = [], open, setOpen,
}) {
  const visibleMenuItems = getVisibleMenuItems(menuItems);

  if (visibleMenuItems.length === 0) {
    return children;
  }

  const content = (
    <ul className="PopoverMenu__MenuList">
      {visibleMenuItems.map((item) => (
        <li key={item.title} className="PopoverMenu__MenuListItem" onClick={item.onClick}>
          {item.icon}
          <span>{item.title}</span>
        </li>
      ))}
    </ul>
  );

  return (
    <Popover
      rootClassName="PopoverMenu__Root"
      content={content}
      trigger="click"
      placement="bottomLeft"
      arrow={false}
      // afterOpenChange={getIsOpen}
      getPopupContainer={() => document.body}
      open={open}
      onOpenChange={(newOpen) => {
        setOpen(newOpen);
      }}
    >
      {children}
    </Popover>
  );
}
